<template>
    <div></div>
</template>
<script>
export default {
    name: "PcFooter",
};
</script>



// WEBPACK FOOTER //
// src/views/layout/pc/Footer.vue